<template>
<div>
  <div v-for="(item, index) in SO_DETAILS" :key="index" class="border mx-1 p-2 mb-3 mt-2 baseContentFont">
    <b-row>
      <b-col md="9"><b>Name: </b>{{ item.name }}</b-col>
      <b-col><b>SSN: </b>{{ formatSSN(item.ssn) }}</b-col>
    </b-row>
    <b-row>
      <b-col md="9"><b>Offender ID: </b>{{ item.offenderId }}</b-col>
      <b-col><b>DOB: </b>{{ item.dob }}</b-col>
    </b-row>
    <div class="border p-1 my-1">
    <b-row>
      <b-col md="4"><b>Offender Status: </b>{{ item.offenderStatus }}</b-col>
      <b-col md="4"><b>Offender Category: </b>{{ item.offenderCategory }}</b-col>
      <b-col md="4"><b>Risk Level: </b>{{ item.riskLevel }}</b-col>
    </b-row>
    <b-row>
      <b-col md="3"><b>SOR ID: </b>{{ item.sorId }}</b-col>
      <b-col md="3"><b>FBI Number: </b>{{ item.fbiNumber }}</b-col>
      <b-col md="3"><b>State ID Number: </b>{{ item.stateIdNumber }}</b-col>
       <b-col md="3"><b>NCIC Number: </b>{{ item.ncicNumber }}</b-col>
    </b-row>
    <b-row>
      <b-col md="4"><b>DL Number: </b>{{ item.dlNumber }}</b-col>
    </b-row>
    <b-row>
      <b-col md="6"><b>Vehicle1: </b>{{ item.vehicle1 }}</b-col>
      <b-col md="6"><b>Vehicle2: </b>{{ item.vehicle2 }}</b-col>
    </b-row>
    <b-row>
      <b-col md="4"><b>Registration Type: </b>{{ item.registrationType }}</b-col>
    </b-row>
    <b-row v-for="(dt, t) in isListEmpty(item.dateType)" :key="t">
      <b-col><span v-if="dt.type">{{ dt.type + ': '}}<span v-if="dt.value">{{ dt.value }}</span></span></b-col>
    </b-row>
    </div>
    <div v-if="isListEmpty(item.sexualOffenseConvictions).length">
    <div v-for="(data, ind) in isListEmpty(item.sexualOffenseConvictions)" :key="ind">
    <BaseELabel :label="`Conviction Details ${data.offenseDate ? '(' + data.offenseDate + ')' : ''} - Record ${ind + 1}`"  class="my-2" new-style />
    <div class="border p-1">
      <b-row>
      <b-col md="4"><b>Court Case Number: </b>{{ data.courtCaseNumber }}</b-col>
      <b-col md="4"><b>Offense Code/Statute: </b>{{ data.offenseCodeStatus }}</b-col>
      <b-col md="4"><b>Jurisdiction: </b>{{ data.jurisidiction }}</b-col>
    </b-row>
    <b-row>
      <b-col md="4"><b>Conviction Date: </b>{{ data.convictionDate }}</b-col>
      <b-col md="4"><b>Offense Description: </b>{{ data.offenseDescription }}</b-col>
      <b-col md="4"><b>Sentence Description: </b>{{ data.sentenceDescription }}</b-col>
    </b-row>
    <b-row>
      <b-col md="4"><b>Minor Victim: </b>{{ data.minorVictim }}</b-col>
      <b-col md="4"><b>Victim Age/Gender: </b>{{ data.victimAgeGender }}</b-col>
      <b-col md="4"><b>Relationship to Victim: </b>{{ data.relationshipToVictim }}</b-col>
    </b-row>
    </div>
    </div>
    </div>
    <div v-else>
      <BaseELabel label="Convictions Details" class="mb-2" new-style />
      <NoRecordFound v-if="!isListEmpty(item.sexualOffenseConvictions).length" ></NoRecordFound>
    </div>

    <div class="my-2">
    <b-row class="my-1">
      <b-col><b>AKAs: </b>
      </b-col>
    </b-row>
    <b-row v-if="isListEmpty(item.sexualOffenseAkas).length" class="px-3">
      <b-col v-for="(x, ind) in isListEmpty(item.sexualOffenseAkas)" :key="ind" md="6" class="border sodContainer">{{ x.name }}</b-col>
    </b-row>
    <NoRecordFound v-else></NoRecordFound>
    </div>
    <div class="my-3">
      <b-row>
      <b-col class="mb-1"><b>Additional Comments: </b>
      <!-- eslint-disable -->
      <span v-html="turnBold(item.additionalComments, '§')"></span>
      <!-- eslint-enable -->
      </b-col>
    </b-row>
    <NoRecordFound v-if="!isListEmpty(item.additionalComments).length"></NoRecordFound>
    </div>
  </div>
  <NoRecordFound v-if="!SO_DETAILS.length" class="mx-1"></NoRecordFound>
  </div>
</template>

<script>
import NoRecordFound from '@src/components/_norecord-found.vue'
export default {
  components: { NoRecordFound },
  props: {
    soDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {

    }
  },
  computed: {
    SO_DETAILS() {
      return this.soDetails || []
    },
  },
  methods: {
    formatSSN(value) {
      return value ? value.trim() ? 'XXX-XX-'+ value.substring(7) : '' : ''
    },
    isListEmpty(list) {
      // to handle empty list when sent as null or [] from API
      return list ? (list.length ? list || [] : []) : []
    },
    turnBold(str, substr) {
      return str ? str.replaceAll(substr, substr.bold()) : ''
    },
  },
}
</script>

<style scoped>
.sodContainer:nth-child(4n+3), .sodContainer:nth-child(4n+4){
    background: #eee;
}
</style>
